import { ResubmitButton } from '@pages/Admin/JobDetailsPage/components/Content/components/MainContent/components/ResubmitButton';
import { useAuthContext } from '@providers/AuthProvider';
import { useState } from 'react';
import { usePageContext } from '../../../../providers/PageProvider';
import { AbandonedProcessingButton } from './components/AbandonedProcessingButton';
import { AIChat } from './components/AIChat';
import { ApplyEnhancementButton } from './components/ApplyEnhancementButton';
import { AssigneeHistorySection } from './components/AssigneeHistorySection';
import { ChangeUnlockTypeButton } from './components/ChangeUnlockTypeButton';
import { CommentsSection } from './components/CommentsSection';
import { EnhancementSection } from './components/EnhancementSection';
import { GeneralSection } from './components/GeneralSection';
import { JobIssuedButton } from './components/JobIssuedButton';
import { PipelineTimestamps } from './components/JobPipelineTimestamps';
import { LicenseUsageHistorySection } from './components/LicenseUsageHistorySection';
import { LiveStatusIndicator } from './components/LiveStatusIndicator';
import { LiveUpdatePageButton } from './components/LiveUpdatePageButton';
import { MaterialsSection } from './components/MaterialsSection';
import { MoreActionsMenu } from './components/MoreActionsMenu';
import { ParseTranscriptButton } from './components/ParseTranscriptButton';
import { ScheduleSection } from './components/ScheduleSection';
import { ShareLink } from './components/ShareLink';
import { TranscriptPlayerButton } from './components/TranscriptPlayerButton';
import { Divider } from './styles/Divider';
import { TopRightSection } from './styles/TopRightSection';

export const MainContent = () => {
  const { me } = useAuthContext();
  const { job, isLoading, metadata } = usePageContext();
  const [isAIChatOpen, setIsAIChatOpen] = useState(true);
  const isVsSuperAdmin = !!(me?.roles?.includes('ROLE_VS_ADMIN') && me.roles?.includes('ROLE_SUPER_ADMIN'));

  if (isLoading && !job) {
    return null;
  }
  if (!job) {
    return <h2>Job not found</h2>;
  }

  return (
    <>
      <TopRightSection>
        <LiveUpdatePageButton />
        <LiveStatusIndicator />
        <TranscriptPlayerButton />
        <ApplyEnhancementButton />
        {isVsSuperAdmin ? <ChangeUnlockTypeButton /> : null}
        <ParseTranscriptButton />
        <ResubmitButton />
        <JobIssuedButton />
        <AbandonedProcessingButton />
        <ShareLink />
        <MoreActionsMenu />
      </TopRightSection>

      <GeneralSection />

      <Divider />

      {metadata ? (
        <>
          <EnhancementSection />
          <Divider />
        </>
      ) : null}

      <ScheduleSection />

      <Divider />

      <MaterialsSection />

      <CommentsSection />

      <AssigneeHistorySection />

      <LicenseUsageHistorySection />

      <PipelineTimestamps />

      {isAIChatOpen && !!job.transcriptId && (
        <AIChat
          transcriptId={job.transcriptId}
          onCloseClick={() => {
            setIsAIChatOpen(false);
          }}
          repositoryId={job.repository?.id}
        />
      )}
    </>
  );
};
